<template>
  <div class="index-page">
    <TheSidebar />

    <v-content transition="out-in">
      <v-container class="px-lg-9" fluid>
        <v-fade-transition mode="out-in">
          <router-view />
        </v-fade-transition>
      </v-container>
    </v-content>
  </div>
</template>

<script>
import TheSidebar from '@/components/TheSidebar.vue';

export default {
  metaInfo: {
    title: 'Home',
  },
  components: {
    TheSidebar,
  },
};
</script>

<style lang="scss" scoped>
.index-page {
  background: #FCFCFC;
  min-height: 100vh;
}
</style>
